import type { Image } from '@wix/public-schemas'
import { sdk } from '@wix/image-kit'

export type UnresolvedImage = Omit<Image, 'url'>

export type ImageResolver = (unResolvedImage: UnresolvedImage) => Image
export const resolveImage: ImageResolver = (unResolvedImage) => {
	const { uri, animated, crop, quality } = unResolvedImage
	const width = unResolvedImage.width || 0
	const height = unResolvedImage.height || 0
	const cropX = crop?.x || 0
	const cropY = crop?.y || 0
	const cropWidth = crop?.width || 0
	const cropHeight = crop?.height || 0
	const targetWidth = cropWidth || width
	const targetHeight = cropHeight || height
	const options = {
		hasAnimation: animated,
		quality,
	}

	const url = sdk.getCropImageURL(
		uri,
		width,
		height,
		cropX,
		cropY,
		cropWidth,
		cropHeight,
		targetWidth,
		targetHeight,
		options
	)
	return {
		...unResolvedImage,
		url,
	}
}
